<script setup>
import { onMounted, ref, watch, defineProps } from 'vue';
import i18n from "@/i18n"
import { getHscode_management_index_category } from "@/service"
import { gethscodeByTemplate } from "@/service/apiList/productLine"
import { getDashboardIndex_standard } from "@/service/apiList/dashboard"
import usetablePageNation from "@/utils/hooks/usetablePageNation" //分页hooks
import dailog from './dailog.vue';
import { useRoute } from 'vue-router';
import { showMessage } from "@/utils/hooks/message"
import { getLangValue } from "@/utils/common"; //获取后端语言
const props = defineProps({
    category_id: {
        type: Number,
        required: true,
        default: 3 // 质量 3  碳足迹 5
    }
})
const visible = ref(false)
const tableInfo = ref([])
const typeList = ref([])
const route = useRoute();
const table_head = ref([
    { name: 'NO.', width: '2%', checked: true },
    { name: getLangValue("dashboard.quality.tableHeader1"), width: '10%', key: 'name', checked: true }, //法规/贸易质量指标
    { name: 'HS Code', width: '8%', key: 'hscode_title', checked: true }, //HScode
    { name: getLangValue("attribute.reference"), key: 'reference', checked: true }, //参考标准
    { name: getLangValue("hscode.category_name"), width: '8%', key: 'category_name', checked: true }, //指标类别
    { name: getLangValue('my.product-line', "table_header1"), width: '8%', key: '0', checked: true, show: true }, //产品线名称
    { name: 'PLID', width: '8%', key: '0', checked: true, show: true }, //PLID
    { name: getLangValue("dashboard.quality.tableHeader2"), width: '8%', key: '1', checked: true, show: true }, //认证方名称
    { name: getLangValue("dashboard.quality.tableHeader3"), width: '8%', key: '1', checked: true, show: true }, //认证方OID
    { name: getLangValue('my.account', "form_companyName"), width: '8%', key: '2', checked: true, show: true }, //公司名称
    { name: getLangValue("dashboard.quality.tableHeader5"), width: '8%', key: '2', checked: true, show: true }, //公司OID
])
const hscodeList = ref([])
const pageSizeOption = [10, 20, 30, 40, 50]
const loading = ref(false)
const { total, currentPage, pageSize, pageOption } = usetablePageNation(getDataList)
const type = ref([])
const hscode = ref('')
const keyword = ref('')
const index_category_lsit = ref([])
const tableAllInfo = ref([])


const getDataList = async () => {
   
    //获取数据
    let params = {
        page: currentPage.value - 1,
        limit: pageSize.value,
        // type: type.value,
        category_id: props.category_id, //质量      
        keyword: keyword.value.trim(),
        hscode_id: hscode.value
    }
    if (!params.hscode_id) {
        showMessage('danger', getLangValue("dashboard.fillDataMessage1"))
        return
    }
    loading.value = true;
    const resp = await getDashboardIndex_standard(params);
    loading.value = false;
    if (resp.code == 0) {
        tableAllInfo.value = resp.payload;
        tableInfo.value = []
        total.value = tableAllInfo.value.length
        if (resp.payload.length == 0) {
            showMessage('info', getLangValue("base.no_data"))
            return
        }
        setTableData();
    }
}

const dailogInfo = ref({
    title: '',
    header: [
        { label: 'ID', key: 'index' },
        { label: 'xaa', key: 'key1' },
        { label: 'xaxaa', key: 'key2' },
    ],
    hscode: '',
    category_id: props.category_id,
    type: 0, // 0 产品线   1 检测机构  2 公司
    list: [],
})
const search = () => {
    //搜索
    currentPage.value = 1;
    getDataList()
}
const getIndicatorCategory = async () => {
    // 获取指标分类list
    const resp = await getHscode_management_index_category();
    if (resp) {
        index_category_lsit.value = resp.payload;
    }
}
const getcategoryname = (type) => {
    // 获取指标分类名称
    let arr = index_category_lsit.value.filter(item => item.id === type)
    if (arr.length > 0) {
        return i18n.global.locale == 'en' ? arr[0].name_en : arr[0].name
    }

}
const gethscodeByTemplateList = async () => {
    //获取模板-目标市场list
    loading.value = true
    const resp = await gethscodeByTemplate();
    loading.value = false;
    if (resp) {
        typeList.value = resp.payload.filter(item => item.destination_market_list.length).map(item => {
            return {
                label: item.name,
                label_en: item.name_en,
                value: item.name,
                children: item.destination_market_list.map(item1 => {
                    return {
                        label: item1.title,
                        label_en: item1.title_en,
                        value: item1.id,
                        database_template_list: item1.database_template_list
                    }
                })
            }
        })
        type.value = route.query.product_template_name
        hscode.value = route.query.hscode
        keyword.value = route.query.keyword
        changeTemplate(0)
        getDataList();
    }
}

const setTableData = () => {
    // 根据分页
    // 根据group筛选
    let startIndex = ((currentPage.value - 1) * pageSize.value) - 1 < 0 ? 0 : ((currentPage.value - 1) * pageSize.value);
    let endIndex = startIndex + pageSize.value;
    total.value = tableAllInfo.value.length
    tableInfo.value = tableAllInfo.value.slice(startIndex, endIndex)

}

const shwoDailog = (key,) => {
    // 设置title
    dailogInfo.value.title = ''
    visible.value = true
    // console.log(key);
    // console.log(id);
    if (key == 0) {
        //产品线名称
        dailogInfo.value.title = getLangValue('my.product-line', "table_header1")
        dailogInfo.value.header = [...[
            { label: 'ID', key: 'index' },
            { label: getLangValue('my.product-line', "table_header1"), key: 'production_line_name' },
            { label: 'PLID', key: 'plid' },
        ]]
        dailogInfo.value.type = 0
        dailogInfo.value.hscode = hscode.value
        console.log(dailogInfo.value);
        // let arr = info.database_list.map(item => item.production_line)
        // const uniqueArr = [...new Map(arr.map(item => [item.id, item])).values()];
        // dailogInfo.value.list = [...uniqueArr]
    } else if (key == 1) {
        dailogInfo.value.title = getLangValue("dashboard.quality.tableHeader2")
        dailogInfo.value.header = [...[
            { label: 'ID', key: 'index' },
            { label: getLangValue("dashboard.quality.tableHeader2"), key: 'testing_institution' },
            { label: getLangValue("dashboard.quality.tableHeader3"), key: 'oid' },
        ]]
        dailogInfo.value.type = 1
        dailogInfo.value.hscode = hscode.value
        // dailogInfo.value.list = [...info.testing_company_list]
    } else {
        dailogInfo.value.title = getLangValue('my.account', "form_companyName")
        dailogInfo.value.header = [...[
            { label: 'ID', key: 'index' },
            { label: getLangValue('my.account', "form_companyName"), key: 'company_name' },
            { label: getLangValue("dashboard.quality.tableHeader5"), key: 'oid' },
        ]]
        dailogInfo.value.type = 2
        dailogInfo.value.hscode = hscode.value
        // let arr = info.database_list.map(item => item.organization)
        // const uniqueArr = [...new Map(arr.map(item => [item.id, item])).values()];
        // dailogInfo.value.list = [...uniqueArr]
    }
}

const changeTemplate = (index = 1) => {
    //模板-目标市场切换
    if (index == 1)
        hscode.value = ''
    if (type.value.length) {
        let arr = typeList.value.filter(item => item.value === type.value[0] && item.children.filter(item1 => item1.value === type.value[1]).length)
        if (arr.length) {
            // 获取shcode
            let arr1 = arr[0].children.filter(item => item.value === type.value[1])
            if (arr1.length) {
                hscodeList.value = arr1[0].database_template_list.map(item => {
                    return {
                        id: item.hscode?.id,
                        title: item.hscode?.title,
                        title_en: item.hscode?.title_en,
                    }
                })
            }
        }
    } else {
        hscodeList.value = []
    }
}


onMounted(() => {
    getIndicatorCategory();
    gethscodeByTemplateList();

})

watch(pageSize, () => {
    currentPage.value = 1;
    setTableData();
})

watch(currentPage, () => {
    setTableData();
})



</script>
<template>
    <div class="indexListTable1 px-3 py-2 " style="height: calc(100% - 1rem) " v-loading="loading">
        <div class="d-flex justify-content-between align-items-center">
            <div class="search d-flex align-items-center">
                <!-- <el-select v-model="type" @change="changeTemplate(1)" filterable clearable
                    :placeholder="getLangValue('dashboard.dataBaseType')" style="max-width: 280px; height: 38px; flex: 1;">
                    <el-option v-for="item in typeList" :key="item.value" :label="item.name" :value="item.name" />
                </el-select> -->
                <el-cascader style="width: 280px; height: 38px;" v-model="type" :options="typeList"
                    :placeholder="getLangValue('dashboard.dataBaseType')" @change="changeTemplate(1)" :props="{label: i18n.global.locale == 'en' ?'label_en': 'label',}" />
                <el-select v-model="hscode" filterable clearable class="mx-2" placeholder="HS Code"
                    style="max-width: 280px; height: 38px;">
                    <el-option v-for="item in hscodeList" :key="item.value" :label=" i18n.global.locale == 'en'? item.title_en : item.title"   :value="item.id" />
                </el-select>
                <!-- <div class="form-icon" style="flex:1; max-width: 360px;">
                    <input style="width: 100%" clearable class="form-control form-control-icon" v-model="keyword"
                        required :placeholder="getLangValue('dashboard.input5')" />
                    <i class="ri-search-line"></i>
                </div> -->
            </div>
            <div class="d-flex">
                <div class="d-flex" style="color: white;">
                    <!-- <button id="btnGroupVerticalDrop1" type="button" class="btn dropdown-toggle"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        style="padding: 0 3px; color: white;">
                        <i class="ri-filter-line"></i>{{ getChecked() }}{{ getLangValue('dashboard.quality.selectLegnth') }}
                    </button>
                    <div class="dropdown-menu " aria-labelledby="btnGroupVerticalDrop1">
                        <template v-for="(hItem) in table_head" :key="hItem">
                            <div class="m-2 d-flex align-items-center">
                                <input class="form-check-input mt-0 mx-2" type="checkbox" v-model="hItem.checked"
                                    aria-label="Checkbox for following text input">
                                <span>{{ hItem.name }}</span>
                            </div>
                        </template>
</div> -->
                </div>
                <button type="button" class="btn btn-success mx-3" @click="search()" style="min-width: 93px;">
                    {{ getLangValue("base.search") }}
                </button>
            </div>
        </div>
        <div style="flex-direction: column; height: calc(100% - 40px);">
            <div class="my-table my-2" id="my-table">
                <!-- 表格信息 -->
                <div style="height:calc(100% - 60px - 1rem); overflow-y: auto;" class="my-scroll-bar">
                    <table class="table table-nowrap ">
                        <!-- table-nowrap -->
                        <thead class="table-light">
                            <tr>
                                <template v-for="(head, index) in table_head.filter(item => item.checked)" :key="index">
                                    <th v-if="head.key == 'reference'" scope="col"
                                        style="color: #212529;max-width: 300px; width: 10%;">
                                        <div class="d-flex align-items-center" style="max-width: 300px;">{{ head.name }}
                                        </div>
                                    </th>
                                    <th v-else scope="col" style="color: #212529;" :width="head.width">
                                        <div class="d-flex align-items-center">{{ head.name }}</div>
                                    </th>
                                </template>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(info, index) in tableInfo" :key="index" style="vertical-align: middle">
                                <td v-for="(item, kk) in table_head.filter(item => item.checked)" :key="kk">
                                    <span v-if="item.show" class="cursor-pointer" @click="shwoDailog(item.key, info)">
                                        <a style="text-decoration: underline !important;color: #299CDB;">
                                            {{ getLangValue('dashboard.Clicktoview') }}
                                        </a>
                                    </span>
                                    <span v-else>
                                        <div v-if="item.key == 'reference'"
                                            :title="i18n.global.locale == 'en' ? info.index_standard?.reference_en : info.index_standard?.reference"
                                            style="width: 100%; max-width: 300px; max-height: 60px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                            {{ i18n.global.locale == 'en' ? info.index_standard?.reference_en :
                                            info.index_standard?.reference }}
                                        </div>
                                        <span v-else-if="item.key == 'hscode_title'">
                                            {{ i18n.global.locale == 'en' ? info.hscode?.title_en : info.hscode?.title }}
                                        </span>
                                        <span v-else-if="item.key == 'category_name'">
                                            {{ info.index_standard && getcategoryname(info.index_standard.category_name)
                                            }}
                                        </span>
                                        <div v-else-if="item.key == 'name'"
                                            :title="i18n.global.locale == 'en' ? info.index_standard?.name_en : info.index_standard?.name"
                                            style="width: 100%; max-width: 350px; max-height: 60px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                                            {{ i18n.global.locale == 'en' ? info.index_standard?.name_en :
                                            info.index_standard?.name }}
                                        </div>
                                        <span v-else>{{ kk == 0 ? index + 1 : info[item.key] }}</span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 分页 -->
                <Pagination v-if="total" v-model:page="currentPage" v-model:perPage="pageSize" :pages="pageOption"
                    :prePageOption="pageSizeOption" :tab_info_length="total" class="me-5 my-3 my-pagination">
                </Pagination>
            </div>
        </div>
        <dailog v-model:visible="visible" v-model:dailogInfo="dailogInfo" :myWidth="400" v-if="visible">
        </dailog>
    </div>

</template>
<style scoped lang="scss">
.indexListTable {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-select__wrapper) {
            background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            color: white;
        }

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-input__wrapper) {
            background-color: #4a5056;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            color: white;
        }


        :deep(.el-input__inner) {
            color: white;
        }

        .form-icon {
            display: inline-block;

            i {
                color: white
            }
        }

        .form-control {
            background-color: #4a5056;
            color: white;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: white;
        }

        .my-pagination {
            color: white;

            :deep(.page_total) {
                color: white !important;
            }
        }
    }
}

.indexListTable1 {
    .search {
        flex: 1;
        height: 38px;

        :deep(.el-select__wrapper) {
            // background-color: #4a5056;
            height: 100%;
        }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            color: #212529;
        }

        :deep(.el-input--suffix) {
            // width: 110px;
            height: 100%;
        }

        :deep(.el-select__wrapper) {
            // background-color: #4a5056;
            height: 100%;
        }

        // :deep(.el-input__wrapper) {
        //     // background-color: #4a5056;
        // }

        :deep(.el-select__placeholder.is-transparent) {
            color: #889AA5 !important;
        }

        :deep(.el-select__selected-item) {
            color: #212529;
        }


        :deep(.el-input__inner) {
            color: #212529;
        }

        .form-icon {
            display: inline-block;

            i {
                color: #212529
            }
        }

        .form-control {
            // background-color: #4a5056;
            color: #212529;
            display: inline-block;
        }
    }

    .my-table {
        flex: 1; //way-2
        height: 100%; //way-2

        // max-height: 500px; // way-1
        table {
            color: #212529;
        }

        .my-pagination {
            color: #212529;

            :deep(.page_total) {
                color: #212529 !important;
            }
        }
    }
}
</style>